import { lazyImport } from '../../../Utils/Loading/loadingHelpers'

const MuiTelInput = lazyImport(() =>
  import('mui-tel-input').then((module) => ({ default: module.MuiTelInput }))
)

export { MuiTelInput }
